/**
 * Public asset paths. Files in ui/public are served at root.
 * Use exact filenames (with spaces) so the dev server serves them.
 * Avoid localhost so production build (e.g. S3) always uses same-origin or configured base.
 */
const PUBLIC_URL = process.env.PUBLIC_URL || '';
const isLocalhostBase = (url) => {
  if (!url || typeof url !== 'string') return false;
  try {
    const u = url.startsWith('http') ? url : `http://x${url}`;
    const origin = new URL(u).origin;
    return origin.includes('localhost') || origin.includes('127.0.0.1');
  } catch (_) {
    return false;
  }
};
const BASE = isLocalhostBase(PUBLIC_URL) ? '' : PUBLIC_URL;

/** API image base URL (no trailing slash). From REACT_APP_IMAGE_URL; fallback derived from API URL. */
const IMAGE_URL_ORIGIN = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_IMAGE_URL)
  ? String(process.env.REACT_APP_IMAGE_URL).replace(/\/+$/, '')
  : '';
const envOrigin = (process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || '').replace(/\/api\/?$/, '');
const PRODUCTION_API_ORIGIN = 'https://api.rwfngo.com';
const API_ORIGIN = IMAGE_URL_ORIGIN || envOrigin || (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production' ? PRODUCTION_API_ORIGIN : '');

/** Base URL used to load API images (uploads). Prefers REACT_APP_IMAGE_URL, then API origin, then production fallback. */
export function getApiOrigin() {
  if (IMAGE_URL_ORIGIN) return IMAGE_URL_ORIGIN;
  if (typeof window !== 'undefined' && window.location && (window.location.hostname === 'rwfngo.com' || window.location.hostname.endsWith('.rwfngo.com'))) {
    return PRODUCTION_API_ORIGIN;
  }
  return API_ORIGIN || envOrigin;
}

/** Normalize URL string for parsing (protocol-relative //localhost -> https:) */
function normalizeUrlString(url) {
  const t = typeof url === 'string' ? url.trim() : '';
  if (!t) return '';
  if (t.startsWith('//')) return `https:${t}`;
  return t;
}

/**
 * Resolve API image/media URL to full path. Rewrites any localhost/127.0.0.1 URL to API_ORIGIN
 * so production (e.g. S3) never loads from localhost. Use for images and media (video) URLs from API.
 */
export const getImageUrl = (imageUrl) => {
  if (imageUrl == null) return null;
  const s = normalizeUrlString(imageUrl);
  if (!s) return null;
  const origin = getApiOrigin();
  if (s.startsWith('http://') || s.startsWith('https://')) {
    if (isLocalhostBase(s) && origin) {
      try {
        const path = new URL(s).pathname;
        return `${origin}${path}`;
      } catch (_) {}
    }
    return imageUrl;
  }
  if (s.startsWith('/')) {
    // Only API upload paths need full origin; same-origin static assets (e.g. /cause-1.png) stay as-is
    if (s.startsWith('/uploads/') && origin) {
      return `${origin}${s}`;
    }
    return imageUrl;
  }
  return imageUrl;
};

export const ASSETS = {
  hero: `${BASE}/main-slider.png`,
  bannerBottom: `${BASE}/bannerbottom.png`,
  bannerHands: `${BASE}/1.png`,
  cause1: `${BASE}/cause-1.png`,
  cause4: `${BASE}/cause-4.png`,
  cause6: `${BASE}/cause-6 1.png`,
  image08: `${BASE}/image-08.png`,
  parallax: `${BASE}/parallax-26.jpg`,
  volunteerShape: `${BASE}/become-volunteer-shape-1.png`,
  spradeBase: `${BASE}/sprade-base.png`,
  rectangle: `${BASE}/Rectangle 161.png`,
  logo: `${BASE}/logo.svg`,
  logoJpeg: `${BASE}/logo.jpeg`,
  /** Images from public folder for About page Mission / History tabs */
  missionImage: `${BASE}/parallax-26.jpg`,
  historyImage: `${BASE}/cause-4.png`,
};
